// @flow
import styled from 'styled-components';

export const RequiredField: any = styled.span`
  font-size: large;
  color: ${({ theme }) => theme.colors.secondary};

  &:before {
    content: '*';
    margin-left: 4px;
  }
`;
